/* eslint-disable import/no-anonymous-default-export */
import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import OtpVerification from "./auth/otp";
import ResetPassword from "./auth/ResetPassword";
import Dashboard from "./dashboard";
import ManageCustomers from "./manageUsers";
import ManageCustomerDetail from "./manageUsers/view";
import BudgetCategories from "./budgetIntelligence/manageCategories";
import AlertsConfiguration from "./budgetIntelligence/alertConfiguration";
import ManageSubadmin from "./manageSubadmin";
import ManageCustomerSupport from "./manageCustomerSupport";
import ManageNotifications from "./manageNotifications";
import RecievedNotifications from "./recievedNotifications";
import ManageCms from "./manageCms";
import SubadminDetail from "./manageSubadmin/viewSubadmin";
import ViewSubadmin from "./manageSubadmin/viewSubadmin";
import AddSubadmin from "./manageSubadmin/addSubadmin";
import ManageSubadminRoles from "./manageSubadmin/roles";
import AddRole from "./manageSubadmin/addRole";
import RoleDetail from "./manageSubadmin/viewRole";
import ManageProfile from "./manageProfile";
import EditProfile from "./manageProfile/edit";
import ChangePassword from "./manageProfile/changePassword";
import ManageRevenue from "./manageRevenue";
import VoiceLibrary from "./aiBehaviorLanguage/voiceLibrary";
import AddVoice from "./aiBehaviorLanguage/voiceLibrary/editVoice";
import MultilngualEngine from "./aiBehaviorLanguage/multilingualEngine";
import MoodMapping from "./aiBehaviorLanguage/moodMapping";
import AddMood from "./aiBehaviorLanguage/moodMapping/addMood";
import DocumentProcessing from "./documentProcessing";
import ManageSubscriptions from "./manageSubscriptions";
import ManageSubscriptionDetail from "./manageSubscriptions/view";
import HydrationGoal from "./hydrationAndGoal";
import AddHydration from "./hydrationAndGoal/addHydration";
import ReminderEngine from "./reminderEngine";
import AddReminder from "./reminderEngine/addReminder";
import LabelRecognition from "./labelRecognition";
import ShoppingMeals from "./shoppinMeals";
import SubCategoriesShopping from "./shoppinMeals/subCategories";
import LocationIntelligence from "./locationIntelligence";
import AddLocation from "./locationIntelligence/addLocation";
import LanguageLibrary from "./translationMesaaging/languageLibrary";
import ViewLanguageLibrary from "./translationMesaaging/languageLibrary/view";
import SmartMessaging from "./translationMesaaging/smartMessaging";
import ManageSharedAccount from "./sharedAccount";
import UserEngagement from "./manageAnalytics/userEngagementDashboard";
import WellnessLifestyle from "./manageAnalytics/wellnessLifestyle";
import FinancialOverview from "./manageAnalytics/financialOverview";
import Settings from "./settings";
import ManageSharedAccountDetail from "./sharedAccount/view";
import EditUser from "./manageUsers/edit";
import ResetPasswordRequests from "./resetPasswordRequests";
import AddDocument from "./documentProcessing/add";
import PermissionDenied from "./permission-denied";

export default {
  Login,
  ForgotPassword,
  OtpVerification,
  ResetPassword,
  Dashboard,
  ManageCustomers,
  ManageCustomerDetail,
  BudgetCategories,
  AlertsConfiguration,
  ManageRevenue,
  ManageSubadmin,
  SubadminDetail,
  ViewSubadmin,
  AddSubadmin,
  ManageSubadminRoles,
  AddRole,
  RoleDetail,
  UserEngagement,
  VoiceLibrary,
  ManageCustomerSupport,
  ManageNotifications,
  RecievedNotifications,
  ManageCms,
  ManageProfile,
  MultilngualEngine,
  EditProfile,
  MoodMapping,
  AddVoice,
  AddMood,
  DocumentProcessing,
  ChangePassword,
  ManageSubscriptions,
  ManageSubscriptionDetail,
  LabelRecognition,
  HydrationGoal,
  AddHydration,
  ShoppingMeals,
  ReminderEngine,
  SubCategoriesShopping,
  LocationIntelligence,
  AddLocation,
  LanguageLibrary,
  ViewLanguageLibrary,
  SmartMessaging,
  AddReminder,
  WellnessLifestyle,
  FinancialOverview,
  Settings,
  ManageSharedAccountDetail,
  EditUser,
  ResetPasswordRequests,
  AddDocument,
  ManageSharedAccount,
  PermissionDenied,
};
